import { render, staticRenderFns } from "./CreateRomanBlind.vue?vue&type=template&id=2a3e7da0"
import script from "./CreateRomanBlind.vue?vue&type=script&lang=js"
export * from "./CreateRomanBlind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports